import * as THREE from 'three';

export const applyClippingPlaneToScene = (scene: THREE.Scene, plane: THREE.Plane | null): void => {
	scene.traverse((object) => {
		if (object instanceof THREE.Mesh) {
			const materialArray = Array.isArray(object.material)
				? object.material
				: [object.material];
			materialArray.forEach((material) => {
				if (!material) return;
				material.clippingPlanes = plane ? [plane] : [];
				material.needsUpdate = true;
			});
		}
		if (object instanceof THREE.LineSegments) {
			if (object.material instanceof THREE.LineBasicMaterial) {
				object.material.clippingPlanes = plane ? [plane] : [];
				object.material.needsUpdate = true;
			}
		}
	});
};
